import { SubmitErrorList, FormValues } from '@ynap/form';
import { Messages } from '../@types';
import { getMessageByKey } from './utils';

export interface AddressFormErrors {
    [key: string]: string | string[] | undefined;
    firstName?: string;
    lastName?: string;
    country?: string;
    addressLine?: string[];
    state?: string[];
}

export interface CollateErrorsProps {
    messages: Messages;
}

export const handleErrorParamsOnFail = (errorParameters: string[], messages: Messages): AddressFormErrors => {
    const [firstErrorParam, field] = errorParameters;
    const errors: AddressFormErrors = {};

    switch (firstErrorParam) {
        case 'ZIPCODE_DOES_NOT_MATCH_STATE':
            errors[field] = messages?.errors?.zipCodeDoesNotMatchState({ zip: String(getMessageByKey(messages?.addressForm?.display, field)) });
            break;
        case 'FIELD_DOES_NOT_MATCH_DROPDOWN':
            errors[field] = messages?.errors?.notMatchDropdown();
            break;
        case 'MANDATORY_FIELD_EMPTY':
            if (field === 'phone') {
                errors[field] = messages?.errors?.phoneRequired();
                break;
            } else {
                errors[field] = messages?.errors?.required({ field: String(getMessageByKey(messages?.addressForm?.display, field)) });
                break;
            }
        case 'FIELD_LENGTH_LESS_THAN_MINIMUM':
        case 'FIELD_LENGTH_GREATER_THAN_MAXIMUM':
            errors[field] = messages?.errors?.regexMismatch();
            break;
        case 'PERSON_TITLE_DOES_NOT_MATCH_DROPDOWN':
            errors[field] = messages?.errors?.personTitleMismatch();
            break;
        default:
            break;
    }
    return errors;
};

export const collateErrors = (values: FormValues, props: CollateErrorsProps, wcsError: SubmitErrorList): AddressFormErrors => {
    let errors: AddressFormErrors = {};
    const { messages } = props;

    wcsError.errors.forEach(({ errorParameters, errorKey, errorMessage }) => {
        switch (errorKey) {
            case 'ERR_INVALID_COUNTRY':
                errors.country = messages?.errors?.invalid?.({ field: String(messages?.addressForm?.display?.country?.()) });
                break;
            case '_ERR_CMD_INVALID_PARAM':
                if (typeof errorParameters === 'string' && errorParameters in values) {
                    errors[errorParameters] =
                        messages?.addressForm?.display && errorParameters in messages.addressForm.display
                            ? messages?.errors?.invalid?.({ field: String(getMessageByKey(messages?.addressForm?.display, errorParameters)) })
                            : errorMessage;
                    break;
                }
                break;
            case 'ERR_ADDRESS_VALIDATION_FAILED':
                if (typeof errorParameters === 'string') {
                    errorParameters = errorParameters.split(' ');
                }
                errors = { ...errors, ...handleErrorParamsOnFail(errorParameters, messages) };
                // WCS returns random fields here like 'nickName' when either 'firstName' or 'lastName' are too long so will just show a generic error message 🤡
                break;
            default:
                errors._error = messages?.errors?.generic?.();
                break;
        }
    });

    return errors;
};
